"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgApp = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_APP", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M8 0c.735 0 1.4 0 2 .009V2.01A142.43 142.43 0 0 0 8 2c-1.942 0-3.198.004-4.123.129-.867.116-1.139.305-1.291.457-.152.152-.34.424-.457 1.291C2.004 4.802 2 6.057 2 8c0 1.942.004 3.198.129 4.123.116.867.305 1.139.457 1.291.152.152.424.34 1.291.457.925.125 2.18.129 4.123.129 1.942 0 3.198-.004 4.123-.129.867-.116 1.139-.305 1.291-.457.152-.152.34-.424.457-1.291.125-.925.129-2.18.129-4.123 0-.766 0-1.426-.01-2h2.001C16 6.6 16 7.265 16 8c0 3.771 0 5.657-1.172 6.828C13.657 16 11.771 16 8 16c-3.771 0-5.657 0-6.828-1.172C0 13.657 0 11.771 0 8c0-3.771 0-5.657 1.172-6.828C2.343 0 4.229 0 8 0Z" }),
    React.createElement("path", { d: "M14 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }))); };
exports.default = SvgApp;
